import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-one-image-with-text',
  templateUrl: './one-image-with-text.component.html',
  styleUrls: ['./one-image-with-text.component.css'],
})
export class OneImageWithTextComponent {
  @Input() data!: any;
}
